import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import { sellerOrders } from "../../actions/order";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Moment from "react-moment";

//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";

class SellerOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: "",
      userId: "",
      orderDetail: "",
      show: "hide",
    };
  }
  async componentDidMount() {
    await this.getOrders();
  }
  getOrders = async () => {
    var data = JSON.parse(localStorage.getItem("user"));

    if (data) {
      const _res = await this.props.sellerOrders(data._id);

      if (_res) {
        this.setState({
          orders: _res.reverse(),
          userId: data._id,
        });
      }
    }
  };
  handleClose = () => {
    this.setState({ show: "hide", productId: 1 });
  };
  handleShow = (orderDetail) => {
    this.setState({ show: "show", orderDetail: orderDetail });
  };
  _openModal = async (e, item) => {
    e.preventDefault();
    this.setState({ orderDetail: item, show: "show" });
  };
  render() {
    const { userId, orders, orderDetail } = this.state;
    return (
      <Fragment>
        <div className="myorders-wrapper  wrapper-90 max-1600">
          <BreadCrumb title={`My Account`} />
          <div className="container-fluid px-0">
            <div className="row">
              <AccountLeftSidebar />
              <div className="col-md-9">
                <header className="sellerCoupons-header">
                  <h3 className="seller-coupon-title">Seller Orders</h3>
                </header>
                <div className="seller-orders-content">
                  {orders &&
                    orders.map((order, index) => (
                      <div key={index} className="ordered-item">
                        <div className="ordered-item-header">
                          <div className="ordered-h-columns">
                            <span className="ordered-h-title">
                              Order Placed
                            </span>
                            <span className="ordered-h-info">
                              <Moment format="DD/MM/YYYY">
                                {order && order.createdAt}
                              </Moment>
                            </span>
                          </div>
                          <div className="ordered-h-columns">
                            <span className="ordered-h-title">Total</span>
                            <span className="ordered-h-info">
                              ${Number(order && order.amount).toFixed(2)}
                            </span>
                          </div>
                          <div className="ordered-h-columns">
                            <span className="ordered-h-title">
                              Sundial Order Number
                            </span>
                            <span className="ordered-h-info">
                              {order && order.transactionId}
                            </span>
                          </div>
                          <div className="ordered-h-columns">
                            <span className="ordered-h-title">Action</span>
                            <div className="edit-seller-order">
                              <button
                                className="edit-seller-orderBtn"
                                onClick={(e) => this._openModal(e, order)}
                              >
                                <span>
                                  <i className="fa fa-eye" />
                                </span>
                                &nbsp;
                                <span className="view-sellerOrder-btn">
                                  View Order
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="ordered-help">
                          <Link to={"/customer-service"}>Get Help</Link>
                        </div>
                        <hr />
                      </div>
                    ))}
                  {/* Modal */}
                  <div
                    id="editSellerOrders"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="editSellerOrdersTitle"
                    aria-hidden="true"
                    className={`modal fade ${this.state.show}`}
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5
                            className="modal-title"
                            id="editSellerOrdersTitle"
                          >
                            Edit Order
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={this.handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="edit-seller-order-content">
                            <div className="edit-seller-info">
                              <h4 className="edit-order-heading">Edit Order</h4>
                              <div className="seller-order-info">
                                <span>Transaction Id</span>
                                <span>
                                  {orderDetail && orderDetail.transactionId}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>Payment Status</span>
                                <span>
                                  {orderDetail && orderDetail.paymentStatus}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>Amount</span>
                                <span>
                                  {" "}
                                  $
                                  {Number(
                                    orderDetail && orderDetail.amount
                                  ).toFixed(2)}
                                </span>
                              </div>
                              <h4 className="edit-order-heading">
                                Billing Details
                              </h4>
                              <div className="seller-order-info">
                                <span>firstName</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.billingDetail.firstName}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>lastName</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.billingDetail.lastName}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>company</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.billingDetail.company}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>address</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.billingDetail.address}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>city</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.billingDetail.city}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>state </span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.billingDetail.state}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>zip</span>
                                <span>
                                  {orderDetail && orderDetail.billingDetail.zip}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>country </span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.billingDetail.country}
                                </span>
                              </div>
                              <h4 className="edit-order-heading">
                                Shipping Details
                              </h4>
                              <div className="seller-order-info">
                                <span>firstName</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.firstName}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>lastName</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.lastName}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>company</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.company}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>address</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.address}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>city</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.city}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>state </span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.state}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>zip</span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.zip}
                                </span>
                              </div>
                              <div className="seller-order-info">
                                <span>country </span>
                                <span>
                                  {orderDetail &&
                                    orderDetail.shippingDetail.country}
                                </span>
                              </div>
                              <h4 className="edit-order-heading">Products</h4>
                              <h5 className="text-center">
                                Product Detail (1)
                              </h5>
                              {orderDetail &&
                                orderDetail.items.map((item, index) => (
                                  <Fragment>
                                    <div className="seller-order-info">
                                      <span>Product Name</span>
                                      <span>{item && item.item.title}</span>
                                    </div>
                                    <div className="seller-order-info">
                                      <span>Quantity </span>
                                      <span>{item.quantity}</span>
                                    </div>
                                  </Fragment>
                                ))}
                              <h4 className="edit-order-heading">Status</h4>
                              <div className="update-seller-order-status">
                                <div className="checkout-inps">
                                  <span className="store-region selectcountry-hint">
                                    Update Order Status
                                  </span>
                                  <select className="region-select countrySelect">
                                    <option value="select country" disabled>
                                      Select Status
                                    </option>
                                    <option value="United States">
                                      Canceled Reversal
                                    </option>
                                    <option value="United States">
                                      Complete
                                    </option>
                                    <option value="United States">
                                      Denied
                                    </option>
                                    <option value="United States">
                                      Expired
                                    </option>
                                    <option value="United States">
                                      Failed
                                    </option>
                                    <option value="United States">Fraud</option>
                                    <option value="United States">
                                      Pending
                                    </option>
                                    <option value="United States">
                                      Processed
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="update-sellerOrder-status"
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            className="cancel-sellerOrder-status"
                            data-dismiss="modal"
                            onClick={this.handleClose}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
sellerOrders.prototype = {
  sellerOrders: PropTypes.func.isRequired,
};
export default connect(null, { sellerOrders })(SellerOrder);
